import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@material-ui/core';

import { AppHeader } from 'components';

import ActivitiesList from 'pages/book-activities-list/components/activities-list/ActivitiesList';

import useStyles from './styles';

const BookActivitiesList = () => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <div className={classes.root}>
      <AppHeader />

      <div className={classes.toolbar}>
        <Typography variant="h2" className={classes.toolbarTitle}>
          {t('Book Activity')}
        </Typography>
      </div>

      <div className={classes.listWrapper}>
        <ActivitiesList />
      </div>
    </div>
  );
};

export default BookActivitiesList;
